import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const impact = c.router(
   {
      getPatientToken: {
         method: 'GET',
         path: '/impact/get-token',
         responses: {
            200: z.string(),
         },
      },
   },
   { strictStatusCodes: true },
);
